import { Button } from 'antd';
import React from 'react';
import { InfraredRayCommand } from '../../Device/Simulator/InfraredRay';

export const ProjectorConfig = (props) => {
    const { masterDevice, onClose } = props;

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px'
        }}>
            <Button onClick={() => {
                masterDevice.sendInfraredRayCommand(InfraredRayCommand.ProjectorDevicePowerOn);
                onClose();
            }}>打开投影机</Button>
            <Button onClick={() => {
                masterDevice.sendInfraredRayCommand(InfraredRayCommand.ProjectorDevicePowerOff);
                onClose();
            }}>关闭投影机</Button>
        </div>
    );
};
